export const ReturnAndRefundPolicy = (showClickAndCollectMessage) => {
	return `To us, no order is complete until you are fully satisfied - this is why we make returns easy. If you change your mind, any unused item with its seals intact, can be returned within 30 days of purchase in the local store.

Please ensure you keep your original receipt or your online order confirmation so we can process the refund accordingly. All refunds will be given by the same method as your original payment.

${showClickAndCollectMessage ? "If your click & collect order hasn't been accepted, you will be automatically refunded within 5 business days." : ''}`;
};

export const DeliveryPolicy = (showClickAndCollectMessage, orderOptions) => {
	return showClickAndCollectMessage
		? `What delivery options do I have?

We don't currently offer delivery to your home address. We have the following click & collect options available for our location:

${orderOptions?.localCheckoutEnabled ? '- Buy online, pick-up in store - You can easily check out online using all payment methods and pick up the product in store. If your order is not confirmed, a refund is issued automatically. Available 7 days a week, subject to store opening hours.\n' : ''}${orderOptions?.productReservationEnabled ? '- Reserve online, pick-up in store - We can also reserve an item for you without any payment if you want to check it out before buying. Available 7 days a week, subject to store opening hours.\n' : ''}
During high season and sale periods, product reservations may not be available.

How soon can I pick up my order?

You will receive an order confirmation email once your item is ready for collection. Typically, this takes 2 hours for most products, but it could be up to 1 business day. Orders placed after 4PM will be processed the next day.

We will be in contact if there are any delays or your order cannot be fulfilled.

How long will you hold my reservation for?

We can hold an item for a maximum of 2 days since the order has been placed. If you have not collected the order by then, we will release the stock and cancel the reservation.`
		: `We don't currently offer delivery to your home address from local stores. Certain items may be available for local delivery depending on the customer postcode.

Please come and visit us to pick up your item or contact us to check delivery services!`;
};
